<p>freight-manager works!</p>
